module.exports = __webpack_public_path__ + "img/4.4d0142f2.png";